<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.pecaSolicitada.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </header>
        <div class="container-fluid">
          <div class="row">
            <div class="col col-lg-12">
              <small translate class="text-info">{{'parametros.pecaSolicitada.cadastro.CampoObrigatorio'}}</small>
              <hr />
            </div>
          </div>
          <div class="row" *ngIf="!carregando">
            <div class="div-check">
              <input id="check" type="checkbox" [checked]="todos" (change)="todosDealers()" />
              <label translate class="label-check"
                for="check">{{'parametros.previsaoCompra.cadastro.dadosPrincipais.todosOsDealers'}}</label>
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-2"
              label="{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.idMargemMO' | translate}}" name="idMargemMO"
              [(ngModel)]="model.id"
              placeholder="{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.idMargemMOPlaceHolder' | translate}}"
              [ativo]="false"></app-text-box>
          </div>
          <div class="row">
            <app-dropdown-list-api [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.dealer' | translate}}" name="dealer"
              [(ngModel)]="model.id_dealer" obrigatorio="true" required filtro="dealer">
            </app-dropdown-list-api>
            <!-- <app-dropdown-list [state]="state" class="col-md-4 col-lg-5" label="Tipo Previsão" name="tipo" [(ngModel)]="model.id_categoria_venda" required [itens]="itensTipo"> </app-dropdown-list> -->
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-5"
              label="{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.ano' | translate}}" name="ano"
              [(ngModel)]="model.ano" obrigatorio="true" required
              placeholder="{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.anoPlaceHolder' | translate}}">
            </app-text-box>
            <app-dropdown-list [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.mes' | translate}}" name="tipoDealer"
              [(ngModel)]="model.mes" required [itens]="meses"></app-dropdown-list>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-10"
              label="{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.quantidade' | translate}}"
              name="valor_previsao" [(ngModel)]="model.valor" obrigatorio="true" required placeholder="0...">
            </app-text-box>
          </div>
          <hr />
          <div class="jumbotron">
            <div class="row">
              <div class="col-10">
                <legend translate>{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.legenda1'}}</legend>
                <legend translate>{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.legenda2'}}</legend>
                <legend translate>{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.legenda3'}}</legend>
                <legend translate>{{'parametros.pecaSolicitada.cadastro.dadosPrincipais.legenda4'}}</legend>
              </div>
              <div class="col-2">
                <div class="float-right mr-4">
                  <a class="btn download" href="assets/modelos/modelo-pecas-solicitadas.xlsx">
                    <i class="fas fa-file-download"></i>
                  </a>
                  {{'parametros.pecaSolicitada.cadastro.dadosPrincipais.modelo' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="state == 1">
            <div class="col col-lg-12">
              <p translate class="text-info">
                {{'parametros.pecaSolicitada.cadastro.dadosPrincipais.adicionarArquivoXlsCadastro'}}</p>
              <p-fileUpload mode="advanced" fileLimit="1" name="myfile[]" customUpload="true" accept=".xlsx"
                (uploadHandler)="uploader($event)"></p-fileUpload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>